<template>
  <div>
    <table class="n-table">
      <thead>
        <th>Nombre</th>
        <th>Número</th>
        <th>País</th>
        <th>Provincia</th>
        <th>Localidad</th>
        <th>CP</th>
        <th>RUCA</th>
        <th>CUIG</th>
        <th>RENSPA</th>
        <th>Actividad</th>
        
        <th>Estado</th>
      </thead>

      <tbody>
        <tr v-for="est in organization.establishments" :key="est.id">
          <td data-label="Nombre">{{ est.name }}</td>
          <td data-label="Número">{{ est.number ? est.number : ' - ' }}</td>
          <td data-label="País">Argentina</td>
          <td data-label="Provincia">{{ est.state }}</td>
          <td data-label="Localidad">{{ est.city }}</td>
          <td data-label="CP">{{ est.zipcode }}</td>
          <td data-label="Matricula RUCA">{{ est.ruca ? est.ruca: '-' }}</td>
          <td data-label="CUIG">{{ est.cuig? est.cuig : '-'}}</td>
          <td data-label="RENSPA">{{ est.renspa? est.renspa : '-'}}</td>
          <td data-label="Actividad">{{ est.activity ? est.activity : ' - '  }}</td>
          
          <td data-label="Estado"><button @click="showConfirmPopup(est)" class="btn">{{ est.active ? 'Deshabilitar' : 'Habilitar' }}</button></td>
        </tr>
      </tbody>
    </table>

      <vs-popup title="Cambio estado establecimiento" :active.sync="confirmPopup"  :button-close-hidden="true" class="confirm-action">
        <div class="alert danger" v-if="establishment.active">
          <vs-icon icon="warning"></vs-icon>
          <span v-if="establishment.id">Esta acción eliminara las ofertas asociadas a este establecimiento, ¿está seguro?</span>
        </div>
        <div v-else class="alert info">
          <vs-icon icon="warning"></vs-icon>
          <span v-if="establishment.id">Usted está habilitando el establecimiento, ¿está seguro?</span>
        </div>

        <div class="footer">
          <button @click="confirmPopup = false" class="cancel" :disabled="loading">Cancelar</button>
          <button class="confirm" @click="toggleEstablishmentActive(establishment.id, establishment.active)" :disabled="loading">{{ loading ? 'Cargando...' : 'Confirmar' }}</button>
        </div>
      </vs-popup>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import axios from 'axios'
import { print } from 'graphql'
import { mapMutations, mapState } from 'vuex'

axios.defaults.headers.common['referer-id'] = new Date().toLocaleString().replace(/[^\d]/g, '') + parseInt(Math.random() * 100000)

const updateEstablishmentMutation = gql`
  mutation updateEstablishment($establishmentId: Int!, $active: Boolean, $name: String, $zipcode: String, $city: String, $state: String, $activity: String, $ruca: String, $cuig: String, $renspa: String, $number: String, $sanitaryProfile: String, $currentUserToken: String!) {
    updateEstablishment(establishmentId: $establishmentId, active: $active, name: $name, zipcode: $zipcode, city: $city, state: $state, activity: $activity, ruca: $ruca, cuig: $cuig, renspa: $renspa, number: $number, sanitaryProfile: $sanitaryProfile, currentUserToken: $currentUserToken) {
      code
      success
      message
    }
  }
`

export default {
  name: 'establishment-admin-tab',
  props: {
    organization: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      establishment: {},
      confirmPopup: false,
      loading: false
    }
  },
  methods: {
    showConfirmPopup (establishment) {
      event.preventDefault()
      this.establishment = {...establishment}
      this.confirmPopup = true
    },
    toggleEstablishmentActive (id, active) {
      this.loading = true
      axios.post(`${process.env.VUE_APP_GRAPH_PATH}`, {
        query: print(updateEstablishmentMutation),
        variables: {
          establishmentId: id,
          active: !active,
          currentUserToken: localStorage.getItem('USER_TOKEN')
        }
      }).then(res => {
        if (!res.data.errors) {
          this.$emit('reload')
        } else {
          console.log(res.data.errors)
        }
      }).finally( () => {
        this.confirmPopup = false
        this.establishment = {}
        this.loading = false
      })
    },
  }

}
</script>
